import { motion } from 'framer-motion'
import qs from 'qs'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import styled from 'styled-components'

import { putDevicesInfo, putDevicesInfo2 } from '@/api/center'
import useInRoom from '@/hooks/useInRoom'
import { deviceInfoStore, useRecoilState, useRecoilValue } from '@/store'
import { convertVersionToNumber } from '@/utils/tool'

import { stepAnimate, TestingDataType } from '..'
// import { putDevicesInfo } from '@/api/global'
import contentoverImg from '../images/content-over.png'
import faultImg from '../images/fault.png'
import remindImg from '../images/remind.png'

const { deviceShowState, fromPageState } = deviceInfoStore

const { devicesDataState, resultState, netNumState, netLowestState, netHighestState, roomInfoState } = deviceInfoStore

interface IProps {
  rtcEngine: any
  next: (step: number, status?: boolean) => void
  off: () => void
  testingData: TestingDataType
  hotLine: () => void
}

export default ({ rtcEngine, next, hotLine, testingData, off }: IProps) => {
  const [fromPage, setFromPage] = useRecoilState(fromPageState)
  const devicesData = useRecoilValue(devicesDataState)
  const result = useRecoilValue(resultState)
  const netNum = useRecoilValue(netNumState)
  const netLowest = useRecoilValue(netLowestState)
  const netHighest = useRecoilValue(netHighestState)
  const roomInfo = useRecoilValue(roomInfoState)
  const [isNormal, setisNormal] = useState<boolean>(false)
  const [version, setversion] = useState<string>('0.0.0')
  const [to1v1Room] = useInRoom()

  useEffect(() => {
    console.log('testingData', testingData)
    const { voice, mike, camera, wifi } = testingData
    const pass = voice && mike && camera && wifi
    localStorage.setItem('deviceTest', `${pass}`)
    setisNormal(pass)
    putDevices(pass)
  }, [testingData])

  const toXbkInRoom = async () => {
    to1v1Room(fromPage)
    setFromPage({})
  }

  // 上报检测结果, 用于历史检测报告
  const putDevices = (pass: boolean) => {
    const userId = localStorage.userid
    const userType = '2'

    // 获取设备信息
    const getDeviceInfo = devicesData
    localStorage.setItem('deviceInfo', JSON.stringify(getDeviceInfo))
    console.log('-------设备信息----，', getDeviceInfo)
    // 摄像头信息
    const cameraInfo = getDeviceInfo?.videoDevices
    let cameraName = ''
    let cameraId = ''
    // 听筒信息
    const speakerInfo = getDeviceInfo?.audioOutputDevices
    let speakerName = ''
    let speakerId = ''
    // 麦克风信息
    const microphoneInfo = getDeviceInfo?.audioInputDevices
    let microphoneName = ''
    let microphoneId = ''
    try {
      cameraName = cameraInfo.map((item) => item.label).join(',')
      cameraId = cameraInfo.map((item) => item.deviceId).join(',')
      speakerName = speakerInfo.map((item) => item.label).join(',')
      speakerId = speakerInfo.map((item) => item.deviceId).join(',')
      microphoneName = microphoneInfo.map((item) => item.label).join(',')
      microphoneId = microphoneInfo.map((item) => item.deviceId).join(',')
    } catch (error) {
      console.error(error)
    }

    // 声网4版本无网络延迟字段
    const netAvg = '0'
    const result = pass ? 1 : 0
    const desc = result || ''
    if (!userId || !userType) {
      return
    }
    const obj = {
      userId,
      userType,
      cameraName,
      cameraId,
      speakerName,
      speakerId,
      microphoneName,
      microphoneId,
      netNum: netNum || '0',
      netAvg,
      netLowest: netLowest || '0',
      netHighest: netHighest || '0',
      result,
      desc
    }
    putDevicesInfo(obj)
      .then((result) => {
        if (result.status === 0) {
          console.error('putDevicesInfo 上报成功')
        }
      })
      .catch((err) => {
        console.error(err)
      })
    putDevicesInfo2({
      brand: 'Web',
      model: '',
      build_version: convertVersionToNumber(import.meta.env.VITE_APP_BUILD_VERSION),
      device_type: 'Web',
      os_version: '',
      memory: ''
      // gen: ''
    })
      .then((result) => {
        if (result.status === 0) {
          console.error('putDevicesInfo2 上报成功')
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }
  const handleNext = () => {
    // window.location.reload()
    next(-1)
  }

  return (
    <Container {...stepAnimate} className="alls-testing">
      {isNormal ? (
        <div className="normal">
          <div className="base-img" />
          <div className="base-title">您的设备很棒，可以准备上课啦！</div>
        </div>
      ) : (
        <div className="abnormal">
          {testingData && !testingData.voice ? (
            <div className="fault">
              <span className="fault-title">扬声器故障：</span>您选择了“听不到声音”
              <span className="fault-remind">请确认没有插入耳机等外接设备</span>
            </div>
          ) : null}
          {testingData && !testingData.mike ? (
            <div className="fault">
              <span className="fault-title">麦克风故障：</span>未检测到声音
              <span className="fault-remind">请检查是否插入麦克风设备，并开启访问权限</span>
            </div>
          ) : null}
          {testingData && !testingData.camera ? (
            <div className="fault">
              <span className="fault-title">摄像头故障：</span>您选择了“看不到画面”
              <span className="fault-remind">请检查摄像头是否被遮挡</span>
            </div>
          ) : null}
          {testingData && !testingData.wifi ? (
            <div className="fault">
              <span className="fault-title">网络故障：</span>网络不佳
              <span className="fault-remind">建议更换网络环境</span>
            </div>
          ) : null}
        </div>
      )}

      <div className="btns">
        <div className="btn-again anim_btn2" onClick={handleNext}>
          重新检测
        </div>
        {!fromPage.timesId ? (
          <div className="btn anim_btn2" onClick={off}>
            退出
          </div>
        ) : null}
        {isNormal && fromPage.timesId ? (
          <div className="btn anim_btn2" onClick={toXbkInRoom}>
            进入教室
          </div>
        ) : null}
        {/* {!isNormal ? <div className="btn anim_btn2" onClick={hotLine}>呼叫技术服务</div>: null} */}
      </div>
    </Container>
  )
}

const Container = styled(motion.div)`
  .normal {
    height: 220px;
    .base-img {
      background-image: url('${contentoverImg}');
    }
  }
  .old {
    text-align: center;
    color: rgba(243, 8, 8, 1);
  }
  .abnormal {
    width: 100%;
    height: 240px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    display: flex;
    justify-content: center;
    flex-direction: column;
    .fault {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &-title,
      &-remind {
        display: flex;
        align-items: center;
      }
      &-title {
        color: rgba(243, 8, 8, 1);
        margin-right: 14px;
      }
      &-title::before {
        content: '';
        width: 20px;
        height: 20px;
        display: block;
        background-image: url('${faultImg}');
        background-position: 0 0;
        background-size: 100% 100%;
        margin-right: 20px;
      }
      &-remind::before {
        content: '';
        width: 20px;
        height: 20px;
        display: block;
        background-image: url('${remindImg}');
        background-position: 0 0;
        background-size: 100% 100%;
        margin: 0 6px 0 20px;
      }
    }
  }
  .btns {
    // display: flex;
    // justify-content: space-around;
    position: relative;
    margin-top: 40px;
    width: 100%;
    padding: 0 50px;
    font-weight: 500;
  }
  .btn {
    margin: 0 auto;
    width: 242px;
    height: 48px;
    line-height: 48px;
    border-radius: 24px;
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    background: #ff5050;
    box-shadow: 0px 3px 0px 0px #d1385f;
  }
  .btn-again,
  .btn-in {
    width: 165px;
    height: 48px;
    background: #fff4f4;
    border-radius: 24px;
    color: #ff5050;
    text-align: center;
    font-size: 18px;
    line-height: 48px;
    box-shadow: 0px 3px 0px 0px #fbe7e7;
    position: absolute;
  }
  .btn-again {
    left: 0px;
  }
  .btn-in {
    right: 50px;
    // color: #fff;
    // background: #FF5050;
    // box-shadow: 0px 3px 0px 0px #D1385F;
  }
`
